/* eslint-disable import/no-unresolved */
import CustomCheckBox from "src/shared/CustomCheckBox";
import { useFormik } from "formik";
import { useAppSelector } from "../../../../../utils/hooks/useAppSelector";
import CustomLabel from "../../../../../shared/CustomLabel";
import CustomReviewField from "../../../../../shared/CustomReviewField";

function BankDetails() {
  const generalDetailsData = useAppSelector((state: any) => state.generalDetails);
  const mefSchema = useAppSelector((state): any => state.masterdata_reducer?.mefJourneySchema);
  const bankDetailsMefFields = mefSchema?.genericDetails || {};
  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnBlur: true,
    initialValues: {
      isCoBorrower:
        generalDetailsData.isCoBorrower || bankDetailsMefFields?.coBorrowerFlag?.defaultValue,
      isGuarantor:
        generalDetailsData.isGuarantor || bankDetailsMefFields?.guarantorFlag?.defaultValue,
      isHousewife:
        generalDetailsData.isHousewife || bankDetailsMefFields?.houseWifeFlag?.defaultValue,
      isPrimaryBorrower:
        generalDetailsData.isPrimaryBorrower ||
        bankDetailsMefFields?.primaryBorrowerFlag?.defaultValue
    },
    onSubmit: () => {}
  });
  return (
    <div>
      <div className="flex justify-start mt-10">
        <p className="text-base font-bold">Bank Details</p>
      </div>
      <div className="grid grid-flow-row-dense lg:grid-cols-3 grid-cols-2 gap-y-8 md:gap-x-28 gap-x-3 mt-6 max-sm:ml-4 ">
        {(generalDetailsData?.bankCustomerId || bankDetailsMefFields?.bankCustomerId?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{bankDetailsMefFields?.bankCustomerId?.label}</CustomLabel>
            <CustomReviewField>{generalDetailsData?.bankCustomerId || "-"}</CustomReviewField>
          </div>
        )}

        {(generalDetailsData?.branchSalesManagerCode ||
          bankDetailsMefFields?.branchSalesManagerCode?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{bankDetailsMefFields?.branchSalesManagerCode?.label}</CustomLabel>
            <CustomReviewField>
              {generalDetailsData?.branchSalesManagerCode || "-"}
            </CustomReviewField>
          </div>
        )}

        {(generalDetailsData?.typeOfLoan || bankDetailsMefFields?.typeOfLoan?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{bankDetailsMefFields?.typeOfLoan?.label}</CustomLabel>
            <CustomReviewField>{generalDetailsData?.typeOfLoan || "-"}</CustomReviewField>
          </div>
        )}

        {(generalDetailsData?.st1Code || bankDetailsMefFields?.st1Code?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{bankDetailsMefFields?.st1Code?.label}</CustomLabel>
            <CustomReviewField>{generalDetailsData?.st1Code || "-"}</CustomReviewField>
          </div>
        )}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 max-w-[500px] my-5 sm:my-8">
        {(formik.values?.isCoBorrower !== undefined ||
          bankDetailsMefFields?.coBorrowerFlag?.visible) && (
          <div className="w-full">
            <CustomCheckBox
              isReview
              label={bankDetailsMefFields?.coBorrowerFlag?.label || "Co-Borrower"}
              name="isCoBorrower"
              handleBlur={formik.handleBlur}
              setFieldValue={formik.setFieldValue}
              checked={formik.values?.isCoBorrower}
            />
          </div>
        )}

        {(formik.values?.isGuarantor !== undefined ||
          bankDetailsMefFields?.guarantorFlag?.visible) && (
          <div className="w-full">
            <CustomCheckBox
              isReview
              label={bankDetailsMefFields?.guarantorFlag?.label || "Guarantor"}
              name="isGuarantor"
              handleBlur={formik.handleBlur}
              setFieldValue={formik.setFieldValue}
              checked={formik.values?.isGuarantor}
            />
          </div>
        )}

        <div className="w-full">
          <CustomCheckBox
            isReview
            label="Primary Borrower"
            name="isPrimaryBorrower"
            handleBlur={formik.handleBlur}
            setFieldValue={formik.setFieldValue}
            checked={formik.values?.isPrimaryBorrower}
          />
        </div>
      </div>
    </div>
  );
}
export default BankDetails;
